import { createFileRoute } from '@tanstack/react-router';
import messages from 'app/_authenticated/funds/messages';
import { SEO } from 'components/Seo/Seo';
import useAppLanguage from 'hooks/useAppLanguage';
import { CryptoDepositCodeComponent } from './components/CryptoDepositCode';

export const Route = createFileRoute(
  '/_authenticated/funds/deposit/crypto/$productCode/address',
)({
  component: CryptoDepositCode,
});

function CryptoDepositCode() {
  const { productCode } = Route.useParams();
  const language = useAppLanguage();

  const fundsMessages = messages[language].seo;
  return (
    <>
      <SEO
        title={fundsMessages.title}
        description={fundsMessages.description}
        keywords={fundsMessages.keywords}
        page={`/funds/deposit/crypto/${productCode}/address`}
      />
      <div className="px-6 py-4">
        <CryptoDepositCodeComponent currency={productCode} />
      </div>
    </>
  );
}
